/*
 * Sudoku — the page. Everything a person touches: the board, the pad, the
 * hint ladder, the puzzle of the day, a puzzle of their own, statistics.
 * The thinking lives in the engine (core / logic / generator / hint) and the
 * shared GameKit; this file only turns it into a screen.
 *
 * The first board is in the markup (resources/views/tools/sudoku.blade.php),
 * so the page is playable before this script wakes; a tap made in that window
 * is handed over by __earlyAction. Why things are the way they are —
 * docs/why/sudoku.md.
 */
(function () {
    'use strict';

    var app = document.getElementById('sdkApp');
    if (!app) return;
    var S = window.SudokuEngine, GK = window.GameKit;
    var stage = document.getElementById('sdkStage');
    if (!S || !GK || !stage) {
        // Without the engine the first screen must not stay a spinner for ever.
        if (window.__earlyAction) ['sudoku', 'sudoku-cell', 'sudoku-pad'].forEach(function (k) { window.__earlyAction.claim(k); });
        if (stage) stage.removeAttribute('data-boot');
        return;
    }

    var CFG = {};
    try { CFG = JSON.parse(app.getAttribute('data-config') || '{}'); } catch (_) { CFG = {}; }
    var T = CFG.t || {}, H = CFG.h || {};
    var SLUG = 'sudoku';
    var SAVE_KEY = 'game', SET_KEY = 'settings';
    var LEVELS = CFG.levels || S.LEVEL_ORDER;
    var POP = S.POP;

    function $(id) { return document.getElementById(id); }
    // ":unit2" must not be read as ":unit" followed by a 2, nor ":ds" as ":d":
    // a placeholder ends where its name ends.
    function tr(text, vars) {
        var s = String(text == null ? '' : text);
        if (!vars) return s;
        return s.replace(/:([a-z][a-z0-9]*)/g, function (all, name) {
            return Object.prototype.hasOwnProperty.call(vars, name) && vars[name] != null ? String(vars[name]) : all;
        });
    }
    function t(key, vars) { return tr(T[key] != null ? T[key] : key, vars); }
    function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    }
    function toast(msg, type) { if (typeof window.__toast === 'function') window.__toast(msg, type || 'info'); }
    function say(msg, loud) {
        if (window.__a11yGrid) window.__a11yGrid.announce(msg, !!loud);
        else if (typeof window.__announce === 'function') window.__announce(msg);
    }
    function fail(err, label, phrase) {
        if (typeof window.__handleError === 'function') window.__handleError(err, label, { say: phrase });
        else toast(phrase, 'error');
    }
    function feature(name, data) { try { if (window.__aeFeature) window.__aeFeature(name, data || {}); } catch (_) {} }
    function funnel(name, data) { try { if (window.__aeFunnel) window.__aeFunnel(name, data || {}); } catch (_) {} }
    function store() { return window.__toolSettings || null; }
    function locale() { return (typeof window.__intlLocale === 'function' && window.__intlLocale()) || undefined; }

    // ── Elements ─────────────────────────────────────────────────────────────
    var boardEl = $('sdkBoard'), overEl = $('sdkOver'), padEl = $('sdkPad'), digitsEl = $('sdkDigits');
    var hintEl = $('sdkHint'), statusEl = $('sdkStatus'), setupEl = $('sdkSetup');
    var cells = [];

    // ── State ────────────────────────────────────────────────────────────────
    var SET = { check: 'solution', limit: false, autoNotes: false, autoClean: true, digitFirst: false, hlPeers: true, hlSame: true, timer: true, lefty: false };
    var G = null;            // the game on the board
    var geo = S.geometry(9);
    var mode = 'play';       // 'play' | 'setup' (entering one's own puzzle)
    var E = null;            // the puzzle being entered: { size, values, marks }
    var stash = null;        // the game put aside while a puzzle is being entered
    var sel = [];            // selected cells; the last one is the cursor
    var armed = 0;           // digit-first: the digit in hand (0 none, -1 eraser)
    var notesMode = false;
    var paused = false;
    var hint = null;         // { res, rung }
    var walking = false;     // "solve step by step" is running
    var over = null;         // what is shown over the board
    var grid = null;         // a11y grid
    var lastPop = -1;
    var stats = GK.stats(SLUG);
    var clock = GK.clock({ onTick: paintClock });
    var immersive = null;
    var calMonth = null, calDay = null;

    // ── Small helpers over the model ─────────────────────────────────────────
    function basicMask(values, i) {
        var m = geo.full, peers = geo.peers[i];
        for (var k = 0; k < peers.length; k++) if (values[peers[k]]) m &= ~(1 << (values[peers[k]] - 1));
        return m;
    }
    // The pencil marks a cell shows: computed minus what the player crossed
    // out (automatic notes), or exactly what the player wrote.
    function shownNotes(i) {
        if (!G || G.values[i]) return 0;
        return SET.autoNotes ? (basicMask(G.values, i) & ~G.excl[i]) : G.notes[i];
    }
    function isGiven(i) { return !!(G && G.givens[i]); }
    function cursor() { return sel.length ? sel[sel.length - 1] : -1; }
    function unitName(u) {
        var kind = S.unitKind(geo, u), n = S.unitIndex(geo, u) + 1;
        return t(kind === 'row' ? 'u_row' : (kind === 'col' ? 'u_col' : 'u_box'), { n: n });
    }
    function listText(items) {
        items = items.map(String);
        if (items.length < 2) return items.join('');
        return items.slice(0, -1).join(', ') + ' ' + t('and') + ' ' + items[items.length - 1];
    }
    function levelName(level) { return t('lvl_' + level); }
    function variantOf(g) { return g.size + ':' + g.level; }
    function formatDay(key, long) {
        var p = String(key).split('-'), d = new Date(+p[0], +p[1] - 1, +p[2]);
        try { return d.toLocaleDateString(locale(), long ? { day: 'numeric', month: 'long', year: 'numeric' } : { day: 'numeric', month: 'long' }); }
        catch (_) { return key; }
    }
    function randomSeed() {
        try {
            var a = new Uint32Array(1);
            (window.crypto || window.msCrypto).getRandomValues(a);
            return a[0] >>> 0;
        } catch (_) {
            return (Date.now() ^ ((window.performance && performance.now()) * 1000)) >>> 0;
        }
    }

    // ── Puzzles: a worker makes them, the page never waits on its main thread ─
    var worker = null, workerBroken = false, jobs = {}, jobId = 0, ready = {};

    function boot() {
        if (worker || workerBroken) return;
        try {
            worker = new Worker(CFG.worker);
            worker.onmessage = function (e) {
                var m = e.data || {}, job = jobs[m.id];
                if (!job) return;
                if (m.progress) { if (job.progress) job.progress(m); return; }
                delete jobs[m.id];
                if (m.ok) job.resolve(m); else job.reject(new Error(m.error || 'worker'));
            };
            worker.onerror = function () {
                // The worker did not start (a blocked script, an old engine): the
                // same code runs on the page instead, one puzzle at a time.
                workerBroken = true;
                var waiting = jobs;
                jobs = {};
                try { worker.terminate(); } catch (_) {}
                worker = null;
                Object.keys(waiting).forEach(function (id) { local(waiting[id].msg, waiting[id].progress).then(waiting[id].resolve, waiting[id].reject); });
            };
        } catch (_) { workerBroken = true; worker = null; }
    }
    function local(msg, progress) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                try {
                    if (msg.cmd === 'generate') resolve({ puzzle: S.generate(msg) });
                    else if (msg.cmd === 'analyze') resolve({ result: S.analyze(msg.values, msg.size) });
                    else if (msg.cmd === 'batch') {
                        var k = 0;
                        (function next() {
                            if (k >= msg.items.length) return resolve({ done: true });
                            var p = S.generate(msg.items[k]);
                            k++;
                            if (progress) progress({ progress: k, total: msg.items.length, puzzle: p });
                            setTimeout(next, 0);
                        })();
                    }
                } catch (err) { reject(err); }
            }, 0);
        });
    }
    function work(msg, progress) {
        boot();
        if (!worker) return local(msg, progress);
        return new Promise(function (resolve, reject) {
            msg.id = ++jobId;
            jobs[msg.id] = { resolve: resolve, reject: reject, progress: progress, msg: msg };
            worker.postMessage(msg);
        });
    }
    function makePuzzle(size, level, seed) {
        return work({ cmd: 'generate', size: size, level: level, seed: seed }).then(function (m) {
            if (!m.puzzle) throw new Error('no puzzle');
            return m.puzzle;
        });
    }
    // The next puzzle of the level being played is prepared while this one is
    // being solved, so "next" opens at once.
    function prepare(size, level) {
        var key = size + ':' + level;
        if (!ready[key]) {
            ready[key] = makePuzzle(size, level, randomSeed());
            ready[key].catch(function () { delete ready[key]; });
        }
        return ready[key];
    }
    function take(size, level) {
        var key = size + ':' + level, p = prepare(size, level);
        delete ready[key];
        return p;
    }

    // ── Saving ───────────────────────────────────────────────────────────────
    function pack(arr) { return Array.prototype.map.call(arr, function (x) { return x.toString(36); }).join('.'); }
    function unpack(text, n) {
        var out = [], parts = String(text || '').split('.');
        for (var i = 0; i < n; i++) out.push(parseInt(parts[i] || '0', 36) || 0);
        return out;
    }
    function snapshot() { return S.format(G.values, '0') + '|' + pack(G.notes) + '|' + pack(G.excl); }
    function restoreSnapshot(text) {
        var p = String(text).split('|'), n = geo.cells;
        G.values = S.parse(p[0]).values || G.values;
        G.notes = unpack(p[1], n);
        G.excl = unpack(p[2], n);
    }
    function save() {
        var st = store();
        if (!st || !G || mode !== 'play') return;
        st.save(SLUG, SAVE_KEY, {
            v: 1, n: G.size, l: G.level, src: G.source, day: G.day || null, seed: G.seed || 0,
            g: S.format(G.givens, '0'), c: snapshot(), ms: clock.elapsed(), mi: G.mistakes, hi: G.hints,
            st: G.started ? 1 : 0, dn: G.done ? 1 : 0, lost: G.lost ? 1 : 0, beat: G.beat || 0,
            un: G.undo.slice(-60)
        });
    }
    function saveSettings() { var st = store(); if (st) st.save(SLUG, SET_KEY, SET); }

    // ── A game ───────────────────────────────────────────────────────────────
    // puzzle: { size, level, givens (string), solution?, tier?, techs? }
    function newGame(puzzle, source, extra) {
        extra = extra || {};
        geo = S.geometry(puzzle.size);
        var givens = S.parse(puzzle.givens).values;
        var solution = puzzle.solution ? S.parse(puzzle.solution).values : S.solve(geo, givens, { limit: 1 }).solution;
        var zeros = [];
        for (var i = 0; i < geo.cells; i++) zeros.push(0);
        G = {
            size: puzzle.size, level: puzzle.level, source: source, day: extra.day || null, seed: puzzle.seed || 0,
            givens: givens, solution: solution, values: givens.slice(), notes: zeros.slice(), excl: zeros.slice(),
            techs: puzzle.techs || null, mistakes: 0, hints: 0, started: false, done: false, lost: false,
            beat: extra.beat || 0, undo: [], redo: []
        };
        return G;
    }
    function open(puzzle, source, extra) {
        closeHint();
        walking = false;
        mode = 'play';
        E = null;
        newGame(puzzle, source, extra);
        sel = [];
        armed = 0;
        notesMode = false;
        paused = false;
        clock.reset(0);
        showOver(null);
        rebuildBoard();
        paintAll();
        save();
        prepare(G.size, LEVELS.indexOf(G.level) >= 0 && S.LEVELS[G.size][G.level] ? G.level : 'easy');
        funnel('sudoku_new', { size: G.size, level: G.level, source: source });
    }

    function gameInProgress() {
        if (!G || G.done || !G.started) return false;
        for (var i = 0; i < geo.cells; i++) if (G.values[i] && !G.givens[i]) return true;
        return false;
    }
    // Leaving an unfinished puzzle is asked about once, on the board itself.
    function guard(run, kind) {
        if (mode === 'setup') leaveSetup(true);
        if (!gameInProgress()) return run();
        showOver({
            kind: 'confirm',
            title: t(kind === 'link' ? 'confirm_link_title' : (kind === 'restart' ? 'confirm_restart_title' : 'confirm_new_title')),
            text: t(kind === 'link' ? 'confirm_link_text' : (kind === 'restart' ? 'confirm_restart_text' : 'confirm_new_text')),
            actions: [
                { label: t(kind === 'link' ? 'confirm_link_yes' : (kind === 'restart' ? 'confirm_restart_yes' : 'confirm_new_yes')), main: true, run: function () { showOver(null); run(); } },
                { label: t('confirm_keep'), run: function () { showOver(null); resumeClock(); } }
            ]
        });
    }

    function startLevel(size, level) {
        if (!S.LEVELS[size] || !S.LEVELS[size][level]) level = 'easy';
        var done = false;
        var wait = setTimeout(function () { if (!done) showOver({ kind: 'busy', title: t('making') }); }, 180);
        take(size, level).then(function (p) {
            done = true; clearTimeout(wait);
            open(p, 'random');
        }, function (err) {
            done = true; clearTimeout(wait);
            showOver(null);
            resumeClock();
            fail(err, 'sudoku_generate', t('t_make_failed'));
        });
    }
    function startDaily(level, day) {
        var done = false;
        var wait = setTimeout(function () { if (!done) showOver({ kind: 'busy', title: t('making') }); }, 180);
        makePuzzle(9, level, S.dailySeed(9, level, day)).then(function (p) {
            done = true; clearTimeout(wait);
            open(p, 'daily', { day: day });
        }, function (err) {
            done = true; clearTimeout(wait);
            showOver(null);
            resumeClock();
            fail(err, 'sudoku_daily', t('t_make_failed'));
        });
    }

    // ── The clock ────────────────────────────────────────────────────────────
    function paintClock(ms) {
        var text = GK.formatTime(ms == null ? clock.elapsed() : ms);
        var el = $('sdkTime'), small = $('sdkTimeB');
        if (el && el.textContent !== text) el.textContent = text;
        if (small && small.textContent !== text) small.textContent = text;
    }
    function resumeClock() {
        if (G && G.started && !G.done && !paused && !over && mode === 'play') clock.start();
    }
    function setPaused(on) {
        if (!G || G.done || mode !== 'play') return;
        paused = !!on;
        stage.classList.toggle('is-paused', paused);
        var btn = $('sdkPause');
        btn.classList.toggle('is-on', paused);
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', t(paused ? 'resume' : 'pause'));
        btn.title = t(paused ? 'resume' : 'pause');
        if (paused) {
            clock.pause();
            save();
            showOver({ kind: 'pause', title: t('paused_title'), text: t('paused_text'), actions: [{ label: t('resume'), main: true, run: function () { setPaused(false); } }] });
        } else {
            showOver(null);
            resumeClock();
        }
    }

    // ── Over the board ───────────────────────────────────────────────────────
    function showOver(spec) {
        over = spec;
        if (!spec) {
            overEl.hidden = true;
            overEl.innerHTML = '';
            return;
        }
        clock.pause();
        var html = '';
        if (spec.kind === 'busy') html += '<div class="sdk-spin" aria-hidden="true"></div>';
        if (spec.title) html += '<h3>' + esc(spec.title) + '</h3>';
        if (spec.html) html += spec.html;
        if (spec.text) html += '<p>' + esc(spec.text) + '</p>';
        if (spec.list) {
            html += '<div class="sdk-over-list">';
            spec.list.forEach(function (a, i) { html += '<button type="button" class="tc-btn ' + (a.main ? '' : 'ghost') + '" data-list="' + i + '">' + esc(a.label) + '</button>'; });
            html += '</div>';
        }
        if (spec.extra) html += spec.extra;
        if (spec.actions) {
            html += '<div class="sdk-over-acts">';
            spec.actions.forEach(function (a, i) { html += '<button type="button" class="tc-btn ' + (a.main ? '' : 'ghost') + '" data-act="' + i + '">' + esc(a.label) + '</button>'; });
            html += '</div>';
        }
        overEl.className = 'sdk-over' + (spec.kind === 'busy' ? ' is-thin' : '');
        overEl.innerHTML = html;
        overEl.hidden = false;
        overEl.setAttribute('role', spec.kind === 'busy' ? 'status' : 'dialog');
        if (spec.title) overEl.setAttribute('aria-label', spec.title);
        var first = overEl.querySelector('button');
        if (first && spec.kind !== 'busy') { try { first.focus({ preventScroll: true }); } catch (_) {} }
    }
    overEl.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !over) return;
        var item = b.hasAttribute('data-act') ? (over.actions || [])[+b.getAttribute('data-act')]
            : (b.hasAttribute('data-list') ? (over.list || [])[+b.getAttribute('data-list')] : null);
        if (item && item.run) item.run();
    });

    function openMenu() {
        var size = G ? G.size : 9;
        var list = Object.keys(S.LEVELS[size]).map(function (level) {
            return { label: levelName(level), main: G && G.level === level && G.source === 'random', run: function () { showOver(null); guard(function () { startLevel(size, level); }); } };
        });
        showOver({
            kind: 'menu', title: t('menu_title'), list: list,
            actions: [
                { label: t('daily_title'), run: function () { showOver(null); guard(function () { startDaily(G && S.LEVELS[9][G.level] ? G.level : 'easy', GK.dailyKey()); }); } },
                { label: t('close'), run: function () { showOver(null); resumeClock(); } }
            ]
        });
    }

    // ── Painting ─────────────────────────────────────────────────────────────
    function rebuildBoard() {
        var n = geo.n, size = String(n);
        stage.setAttribute('data-size', size);
        var have = boardEl.querySelectorAll('.sdk-cell');
        if (have.length !== geo.cells) {
            var html = '';
            for (var i = 0; i < geo.cells; i++) html += '<div class="sdk-cell" role="gridcell" tabindex="-1" data-i="' + i + '"></div>';
            boardEl.innerHTML = html;
            if (grid) grid.destroy();
            grid = null;
        }
        cells = Array.prototype.slice.call(boardEl.querySelectorAll('.sdk-cell'));
        cells.forEach(function (el, i) {
            el._sig = '';
            el.removeAttribute('data-early-action');
            el.style.setProperty('--k', String(((i / n) | 0) + (i % n)));
        });
        if (!grid && window.__a11yGrid) {
            grid = window.__a11yGrid.create(boardEl, {
                name: t('a_board'),
                cols: function () { return geo.n; },
                cells: function () { return cells; },
                label: cellLabel,
                onActivate: function (i) { tapCell(i, {}); },
                onFocusCell: function (i) { if (cursor() !== i) { sel = [i]; paintAll(); } }
            });
        } else if (grid) {
            grid.refresh();
        }
        // The digit pad follows the board size.
        Array.prototype.forEach.call(digitsEl.querySelectorAll('.sdk-d'), function (b) { b.hidden = +b.getAttribute('data-d') > n; });
        var levels = S.LEVELS[n];
        Array.prototype.forEach.call(document.querySelectorAll('#sdkLevels .tc-seg-b'), function (b) { b.hidden = !levels[b.getAttribute('data-level')]; });
        var sizeSel = $('sdkSize');
        if (sizeSel) sizeSel.value = size;
    }
    var edge = {};
    function edgeClass(i) {
        var key = geo.n + ':' + i;
        if (edge[key] != null) return edge[key];
        var n = geo.n, r = (i / n) | 0, c = i % n, cls = '';
        cls += c === n - 1 ? ' er' : ((c + 1) % geo.bw === 0 ? ' br' : '');
        cls += r === n - 1 ? ' eb' : ((r + 1) % geo.bh === 0 ? ' bb' : '');
        return (edge[key] = cls);
    }
    function cellLabel(el) {
        var i = +el.getAttribute('data-i'), n = geo.n;
        var where = t('a_cell', { r: ((i / n) | 0) + 1, c: (i % n) + 1 });
        var values = mode === 'setup' ? E.values : (G ? G.values : []);
        var v = values[i], what;
        if (v) {
            what = (mode === 'setup' || isGiven(i)) ? t('a_given', { d: v }) : String(v);
            if (mode === 'play' && wrongNow(i)) what += ', ' + t('a_wrong');
        } else {
            var notes = mode === 'play' ? shownNotes(i) : 0;
            what = notes ? t('a_notes', { list: S.digitsOf(notes).join(' ') }) : t('a_empty');
        }
        return where + ', ' + what;
    }
    function wrongNow(i) {
        return SET.check === 'solution' && G && !G.givens[i] && G.values[i] && G.values[i] !== G.solution[i];
    }
    function notesHtml(mask, focusDigit, marks) {
        var n = geo.n, html = '<span class="sdk-notes">';
        for (var d = 1; d <= n; d++) {
            var bit = 1 << (d - 1), cls = '';
            if (marks && (marks.kill & bit)) cls = 'kill';
            else if (marks && (marks.key & bit)) cls = 'key';
            else if (marks && (marks.alt & bit)) cls = 'alt';
            else if (focusDigit === d && (mask & bit)) cls = 'on';
            html += '<i' + (cls ? ' class="' + cls + '"' : '') + '>' + ((mask & bit) ? d : '') + '</i>';
        }
        return html + '</span>';
    }

    // What the hint paints: classes per cell and marks per candidate.
    function hintLayer() {
        var layer = { cls: {}, marks: {}, cand: {}, ghost: {} };
        if (!hint || mode !== 'play') return layer;
        var res = hint.res, rung = hint.rung, k;
        function add(i, c) { layer.cls[i] = (layer.cls[i] ? layer.cls[i] + ' ' : '') + c; }
        if (res.kind === 'mistake') { if (rung >= 3) res.cells.forEach(function (i) { add(i, 'h-hit'); }); return layer; }
        if (res.kind === 'note') { if (rung >= 3) add(res.cell, 'h-key'); return layer; }
        if (res.kind !== 'step') return layer;
        var step = res.step, f = step.focus || {};
        if (f.type === 'unit') f.units.forEach(function (u) { geo.units[u].forEach(function (i) { add(i, 'h-band'); }); });
        if (rung < 3) {
            if (f.type === 'cells') f.cells.forEach(function (i) { add(i, 'h-band'); });
            if (f.type === 'digit') layer.digit = f.digit;
            return layer;
        }
        var digitBit = 0;
        (step.digits || []).forEach(function (d) { digitBit |= 1 << (d - 1); });
        (step.cand || []).forEach(function (c) { layer.cand[c[0]] = c[1]; });
        function mark(i, kind, mask) {
            var m = layer.marks[i] || (layer.marks[i] = { key: 0, alt: 0, kill: 0 });
            m[kind] |= mask;
        }
        var altCells = step.tech === 'simple_coloring' ? step.colorB : (step.roof || step.wings || step.link || []);
        step.cells.forEach(function (i) {
            var alt = altCells.indexOf(i) >= 0 && step.tech !== 'w_wing';
            if (step.tech === 'w_wing') alt = (step.link || []).indexOf(i) >= 0;
            add(i, alt ? 'h-alt' : 'h-key');
            if (!step.place) mark(i, alt ? 'alt' : 'key', step.tech === 'w_wing' && alt ? (1 << (step.linkDigit - 1)) : digitBit);
        });
        (step.because || []).forEach(function (i) { add(i, 'h-why'); });
        (step.elim || []).forEach(function (e) { if (step.cells.indexOf(e[0]) < 0) add(e[0], 'h-hit'); mark(e[0], 'kill', e[1]); });
        (step.place || []).forEach(function (p) { add(p[0], 'h-put'); layer.ghost[p[0]] = p[1]; });
        if (step.tech === 'forcing') {
            (step.chain || []).forEach(function (c) { add(c.cell, 'h-band'); });
            if (step.wall && step.wall.kind === 'cell') add(step.wall.cell, 'h-hit');
        }
        return layer;
    }

    function paintAll() {
        var values = mode === 'setup' ? E.values : G.values;
        var n = geo.n, cur = cursor(), i;
        var layer = hintLayer(), hinting = !!hint && mode === 'play';
        var focusDigit = hinting ? (layer.digit || 0) : (armed > 0 ? armed : (cur >= 0 && values[cur] ? values[cur] : 0));
        var inSel = {}, peer = {}, clash = {};
        sel.forEach(function (c) { inSel[c] = 1; });
        if (SET.hlPeers && cur >= 0 && sel.length === 1) geo.peers[cur].forEach(function (c) { peer[c] = 1; });
        if (mode === 'setup' || SET.check !== 'off') S.conflicts(geo, values).forEach(function (c) { clash[c] = 1; });
        var marksE = mode === 'setup' && E.marks ? E.marks : null;

        for (i = 0; i < geo.cells; i++) {
            var el = cells[i], v = values[i], given = mode === 'setup' ? false : !!G.givens[i];
            var cls = 'sdk-cell' + edgeClass(i) + (given || (mode === 'setup' && v) ? ' g' : '');
            if (!hinting) {
                if (inSel[i]) cls += ' sel' + (i === cur ? ' cur' : '');
                else if (SET.hlSame && focusDigit && v === focusDigit) cls += ' same';
                else if (peer[i]) cls += ' peer';
            } else {
                if (i === cur) cls += ' cur';
                if (focusDigit && v === focusDigit) cls += ' same';
            }
            if (clash[i]) cls += given ? ' clash' : ' bad';
            else if (mode === 'play' && wrongNow(i)) cls += ' bad';
            if (marksE && marksE[i]) cls += ' h-hit';
            if (layer.cls[i]) cls += ' ' + layer.cls[i];
            if (i === lastPop) cls += ' pop';
            var inner;
            if (v) inner = String(v);
            else if (layer.ghost[i]) inner = '<span class="sdk-ghost">' + layer.ghost[i] + '</span>';
            else if (mode === 'play') {
                var mask = layer.cand[i] != null ? layer.cand[i] : shownNotes(i);
                var m = layer.marks[i];
                if (m) mask |= m.kill;
                inner = mask ? notesHtml(mask, focusDigit, m) : '';
            } else inner = '';
            var sig = cls + '|' + inner;
            if (el._sig !== sig) {
                el._sig = sig;
                el.className = cls;
                el.innerHTML = inner;
            }
        }
        lastPop = -1;
        if (grid) grid.relabel();
        paintPad(values);
        paintBar();
    }

    function paintPad(values) {
        var n = geo.n, count = [], i;
        for (i = 0; i <= n; i++) count.push(0);
        for (i = 0; i < geo.cells; i++) if (values[i]) count[values[i]]++;
        Array.prototype.forEach.call(digitsEl.querySelectorAll('.sdk-d'), function (b) {
            var d = +b.getAttribute('data-d');
            if (d > n) return;
            var left = Math.max(0, n - count[d]);
            b.style.setProperty('--done', String(Math.min(1, count[d] / n)));
            b.classList.toggle('is-full', left === 0 && mode === 'play');
            b.classList.toggle('is-armed', armed === d);
            b.lastElementChild.textContent = String(left);
            b.setAttribute('aria-label', left ? t('digit_left', { d: d, n: left }) : t('digit_done', { d: d }));
            if (SET.digitFirst) b.setAttribute('aria-pressed', armed === d ? 'true' : 'false'); else b.removeAttribute('aria-pressed');
        });
        var play = mode === 'play' && G;
        $('sdkUndo').disabled = !(play && G.undo.length && !G.done);
        $('sdkRedo').disabled = !(play && G.redo.length && !G.done);
        var notesBtn = $('sdkNotes');
        notesBtn.classList.toggle('is-on', notesMode);
        notesBtn.setAttribute('aria-pressed', notesMode ? 'true' : 'false');
        notesBtn.disabled = mode !== 'play';
        $('sdkErase').classList.toggle('is-on', armed === -1);
        $('sdkHintBtn').disabled = mode !== 'play' || !G || G.done;
    }

    function paintBar() {
        if (!G) return;
        var levelKnown = !!T['lvl_' + G.level];
        $('sdkLevelName').textContent = levelKnown ? levelName(G.level) : t('new_game');
        Array.prototype.forEach.call(document.querySelectorAll('#sdkLevels .tc-seg-b'), function (b) {
            var on = mode === 'play' && G.source !== 'own' && G.source !== 'shared' && b.getAttribute('data-level') === G.level;
            b.classList.toggle('on', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        stage.setAttribute('data-level', G.level);
        $('sdkClock').hidden = !SET.timer;
        var mist = $('sdkMist');
        mist.hidden = SET.check !== 'solution' || mode !== 'play';
        $('sdkMistN').textContent = SET.limit ? (G.mistakes + ' / 3') : String(G.mistakes);
        mist.classList.toggle('is-bad', SET.limit && G.mistakes >= 2);
        var src = '';
        if (mode === 'play') {
            if (G.source === 'daily') src = t('source_daily', { date: formatDay(G.day) });
            else if (G.source === 'own') src = t('source_own') + ' · ' + levelName(G.level);
            else if (G.source === 'shared') src = t('source_shared') + (G.beat ? ' · ' + t('beat_time', { time: GK.formatTime(G.beat) }) : '');
        }
        $('sdkSrc').textContent = src;
        if (!hint && mode === 'play') {
            var left = 0;
            for (var i = 0; i < geo.cells; i++) if (!G.values[i]) left++;
            var about = G.size === 9 ? t('lvl_' + G.level + '_d') : t('lvl_small_d');
            $('sdkStText').textContent = (G.started && !G.done ? t('cells_left', { n: left }) + ' · ' : '') + about;
            // Where the bar has no room for it (the whole-screen board), the
            // status line carries the level and the mistakes as well.
            $('sdkStMore').textContent = (levelKnown ? levelName(G.level) + ' · ' : '')
                + (SET.check === 'solution' ? t('mistakes') + ': ' + (SET.limit ? G.mistakes + ' / 3' : G.mistakes) + ' · ' : '');
        }
        statusEl.hidden = !!hint || mode !== 'play';
        setupEl.hidden = mode !== 'setup';
    }

    // ── Moves ────────────────────────────────────────────────────────────────
    function begin() {
        if (!G.started) {
            G.started = true;
            try { if (window.__stage) window.__stage('playing', { level: G.level, size: G.size }); } catch (_) {}
        }
        if (!paused && !over) clock.start();
    }
    function remember() {
        G.undo.push(snapshot());
        if (G.undo.length > 600) G.undo.shift();
        G.redo = [];
    }
    function settle(announce) {
        save();
        paintAll();
        if (announce) say(announce);
        checkEnd();
    }
    function cleanPeers(cell, d) {
        if (SET.autoNotes || !SET.autoClean) return;
        var bit = 1 << (d - 1);
        geo.peers[cell].forEach(function (p) { G.notes[p] &= ~bit; });
    }
    function putDigit(cell, d) {
        if (G.givens[cell]) { say(t('t_given')); return false; }
        if (G.values[cell] === d) return eraseCell(cell);
        begin();
        remember();
        G.values[cell] = d;
        cleanPeers(cell, d);
        lastPop = cell;
        if (SET.check === 'solution' && d !== G.solution[cell]) {
            G.mistakes++;
            if (SET.limit && G.mistakes >= 3 && !G.lost) { settle(t('a_wrong')); return lose(); }
            settle(t('a_placed', { d: d }) + ', ' + t('a_wrong'));
        } else settle(t('a_placed', { d: d }));
        return true;
    }
    function toggleNote(list, d) {
        var bit = 1 << (d - 1), empty = list.filter(function (c) { return !G.values[c]; });
        if (!empty.length) return false;
        begin();
        remember();
        var allHave = empty.every(function (c) { return shownNotes(c) & bit; });
        empty.forEach(function (c) {
            if (SET.autoNotes) {
                if (!(basicMask(G.values, c) & bit)) return;
                if (allHave) G.excl[c] |= bit; else G.excl[c] &= ~bit;
            } else if (allHave) G.notes[c] &= ~bit; else G.notes[c] |= bit;
        });
        settle(t(allHave ? 'a_note_off' : 'a_note_on', { d: d }));
        return true;
    }
    function eraseCell(cell) {
        if (G.givens[cell]) return false;
        if (!G.values[cell] && !shownNotes(cell) && !G.excl[cell]) return false;
        begin();
        remember();
        if (G.values[cell]) G.values[cell] = 0;
        else { G.notes[cell] = 0; G.excl[cell] = 0; }
        settle(t('a_erased'));
        return true;
    }
    function undo() {
        if (!G || !G.undo.length || G.done) return;
        G.redo.push(snapshot());
        restoreSnapshot(G.undo.pop());
        closeHint();
        settle(t('undo'));
    }
    function redo() {
        if (!G || !G.redo.length || G.done) return;
        G.undo.push(snapshot());
        restoreSnapshot(G.redo.pop());
        closeHint();
        settle(t('redo'));
    }

    // A digit arrives — from the pad or the keyboard.
    function enterDigit(d, forceNote) {
        if (over || paused) return;
        if (d > geo.n) return;
        if (mode === 'setup') {
            var c0 = cursor();
            if (c0 < 0) return;
            E.values[c0] = d;
            E.marks = null;
            setSetupMsg('', '');
            stepSetup(1);
            return;
        }
        if (!G || G.done) return;
        if (hint && !walking) closeHint();
        if (!sel.length) return;
        if (sel.length > 1) { toggleNote(sel, d); return; }
        if (forceNote ? !notesMode : notesMode) toggleNote(sel, d);
        else putDigit(sel[0], d);
    }
    // Entering a puzzle is typing: a digit or an empty cell moves on to the
    // next cell, Backspace steps back — a whole row goes in without the mouse.
    function stepSetup(by) {
        var next = Math.max(0, Math.min(geo.cells - 1, cursor() + by));
        sel = [next];
        if (grid) grid.setIndex(next);
        paintAll();
    }
    function eraseSelection(by) {
        if (over || paused) return;
        if (mode === 'setup') {
            sel.forEach(function (c) { E.values[c] = 0; });
            E.marks = null;
            setSetupMsg('', '');
            if (by) stepSetup(by); else paintAll();
            return;
        }
        if (!G || G.done) return;
        sel.forEach(function (c) { eraseCell(c); });
    }

    // ── Selecting ────────────────────────────────────────────────────────────
    function tapCell(i, ev) {
        if (over || paused) return;
        var values = mode === 'setup' ? E.values : G.values;
        if (mode === 'play' && SET.digitFirst && armed !== 0 && !G.done) {
            sel = [i];
            // A given cell hands over its digit; any other cell takes the one in hand.
            if (armed === -1) { if (!eraseCell(i)) paintAll(); }
            else if (G.givens[i]) { armed = values[i]; paintAll(); }
            else if (notesMode) { if (!toggleNote([i], armed)) paintAll(); }
            else putDigit(i, armed);
            if (grid) grid.setIndex(i);
            return;
        }
        if (ev && (ev.ctrlKey || ev.metaKey || ev.shiftKey) && mode === 'play') {
            var at = sel.indexOf(i);
            if (at >= 0 && sel.length > 1) sel.splice(at, 1); else if (at < 0) sel.push(i);
        } else sel = [i];
        if (grid) grid.setIndex(i);
        paintAll();
    }
    function moveCursor(dr, dc, extend) {
        var n = geo.n, cur = cursor();
        if (cur < 0) cur = 0;
        var r = Math.max(0, Math.min(n - 1, ((cur / n) | 0) + dr)), c = Math.max(0, Math.min(n - 1, (cur % n) + dc));
        var next = r * n + c;
        if (extend && mode === 'play') { sel = sel.filter(function (x) { return x !== next; }).concat([next]); } else sel = [next];
        if (grid) grid.focus(next, true);
        paintAll();
    }

    // The board: a tap is the browser's click. A mouse held down and dragged
    // over other cells selects them all (for one note in several cells); a
    // finger is never tracked — on a phone the board is where the page scrolls.
    var drag = null, dragEndedAt = -1;
    boardEl.addEventListener('click', function (e) {
        if (e.detail !== 0 && dragEndedAt >= 0 && e.timeStamp - dragEndedAt < 400) { dragEndedAt = -1; return; }
        var el = e.target.closest('.sdk-cell');
        if (!el) return;
        tapCell(+el.getAttribute('data-i'), e);
    });
    boardEl.addEventListener('pointerdown', function (e) {
        dragEndedAt = -1;
        if (e.pointerType !== 'mouse' || e.button !== 0 || mode !== 'play') return;
        var el = e.target.closest('.sdk-cell');
        if (el) drag = { from: +el.getAttribute('data-i'), moved: false };
    });
    boardEl.addEventListener('pointerover', function (e) {
        if (!drag || e.pointerType !== 'mouse') return;
        if (!(e.buttons & 1)) { drag = null; return; }
        var el = e.target.closest('.sdk-cell');
        if (!el) return;
        var i = +el.getAttribute('data-i');
        if (!drag.moved) {
            if (i === drag.from) return;
            drag.moved = true;
            sel = [drag.from];
        }
        if (sel.indexOf(i) < 0) { sel.push(i); paintAll(); }
    });
    window.addEventListener('pointerup', function (e) {
        if (drag && drag.moved) dragEndedAt = e.timeStamp;
        drag = null;
    });
    window.addEventListener('pointercancel', function () { drag = null; });

    // ── The pad ──────────────────────────────────────────────────────────────
    function padDigit(d) {
        if (mode === 'play' && SET.digitFirst) {
            armed = armed === d ? 0 : d;
            paintAll();
            return;
        }
        enterDigit(d, false);
    }
    function padAction(name) {
        if (name === 'undo') undo();
        else if (name === 'redo') redo();
        else if (name === 'erase') {
            if (mode === 'play' && SET.digitFirst) { armed = armed === -1 ? 0 : -1; paintAll(); } else eraseSelection();
        } else if (name === 'notes') setNotesMode(!notesMode);
        else if (name === 'hint') askHint();
    }
    function setNotesMode(on) {
        if (mode !== 'play') return;
        notesMode = !!on;
        paintAll();
        say(t(notesMode ? 'a_notes_mode_on' : 'a_notes_mode_off'));
    }
    padEl.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || b.disabled) return;
        if (b.hasAttribute('data-d')) padDigit(+b.getAttribute('data-d'));
        else if (b.id === 'sdkUndo') padAction('undo');
        else if (b.id === 'sdkRedo') padAction('redo');
        else if (b.id === 'sdkErase') padAction('erase');
        else if (b.id === 'sdkNotes') padAction('notes');
        else if (b.id === 'sdkHintBtn') padAction('hint');
    });

    // ── Keyboard ─────────────────────────────────────────────────────────────
    var stageActive = false;
    document.addEventListener('pointerdown', function (e) { stageActive = stage.contains(e.target); }, true);
    stage.addEventListener('focusin', function () { stageActive = true; });
    boardEl.addEventListener('keydown', function (e) {
        // Shift + arrow grows the selection; the grid's own arrows would move it.
        if (!e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return;
        var step = { ArrowLeft: [0, -1], ArrowRight: [0, 1], ArrowUp: [-1, 0], ArrowDown: [1, 0] }[e.key];
        if (!step) return;
        e.preventDefault();
        e.stopPropagation();
        moveCursor(step[0], step[1], true);
    }, true);
    document.addEventListener('keydown', function (e) {
        if (!stageActive || e.defaultPrevented || e.altKey) return;
        var tag = e.target && e.target.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (e.target && e.target.isContentEditable)) return;
        // Letters by the physical key: Ctrl+Z is the same key on a Russian layout.
        var key = e.key, mod = e.ctrlKey || e.metaKey, code = e.code || '';
        var letter = /^Key[A-Z]$/.test(code) ? code.charAt(3).toLowerCase() : (key.length === 1 ? key.toLowerCase() : '');
        if (mod) {
            if (letter === 'z') { e.preventDefault(); if (e.shiftKey) redo(); else undo(); }
            else if (letter === 'y') { e.preventDefault(); redo(); }
            return;
        }
        if (key === 'Escape') {
            if (over && over.kind !== 'busy' && over.kind !== 'win') { if (paused) setPaused(false); else { showOver(null); resumeClock(); } e.preventDefault(); }
            else if (hint) { closeHint(); e.preventDefault(); }
            return;
        }
        if (over) return;
        var arrows = { ArrowLeft: [0, -1], ArrowRight: [0, 1], ArrowUp: [-1, 0], ArrowDown: [1, 0] }[key];
        if (arrows) { e.preventDefault(); moveCursor(arrows[0], arrows[1], e.shiftKey); return; }
        // The digit by the physical key: Shift + 1 types "!" on most layouts.
        var digit = 0;
        if (/^Digit[0-9]$/.test(code)) digit = +code.charAt(5);
        else if (/^Numpad[0-9]$/.test(code)) digit = +code.charAt(6);
        else if (/^[0-9]$/.test(key)) digit = +key;
        if (/^(Digit|Numpad)[0-9]$/.test(code) || /^[0-9]$/.test(key)) {
            e.preventDefault();
            if (digit === 0) eraseSelection(1); else enterDigit(digit, e.shiftKey);
            return;
        }
        if (key === 'Backspace') { e.preventDefault(); eraseSelection(-1); return; }
        if (key === 'Delete' || (mode === 'setup' && (key === '.' || key === ' '))) { e.preventDefault(); eraseSelection(1); return; }
        if (letter === 'n') { e.preventDefault(); setNotesMode(!notesMode); }
        else if (letter === 'h') { e.preventDefault(); askHint(); }
        else if (letter === 'p') { e.preventDefault(); setPaused(!paused); }
        else if (letter === 'u') { e.preventDefault(); undo(); }
    });

    // ── The end of a game ────────────────────────────────────────────────────
    function checkEnd() {
        if (!G || G.done || mode !== 'play') return;
        for (var i = 0; i < geo.cells; i++) if (!G.values[i]) return;
        for (i = 0; i < geo.cells; i++) {
            if (G.values[i] !== G.solution[i]) {
                if (SET.check !== 'solution') {
                    toast(t('full_wrong'), 'warning');
                    say(t('full_wrong'), true);
                }
                return;
            }
        }
        win();
    }
    function win() {
        clock.pause();
        var ms = clock.elapsed();
        G.done = true;
        closeHint();
        walking = false;
        var assisted = G.hints > 0;
        var out = stats.record({ variant: variantOf(G), won: true, ms: ms, assisted: assisted, daily: G.source === 'daily' ? G.day : null });
        save();
        boardEl.classList.add('won');
        setTimeout(function () { boardEl.classList.remove('won'); }, 1400);
        paintAll();
        say(t('a_solved', { time: GK.formatTime(ms) }), true);
        try {
            if (window.__aeToolComplete) window.__aeToolComplete({ level: G.level, size: G.size, won: 1, ms: ms, hints: G.hints, mistakes: G.mistakes, source: G.source });
        } catch (_) {}

        var best = out.summary.bestMs;
        var res = '<div class="sdk-res">'
            + '<div><b>' + esc(GK.formatTime(ms)) + '</b><span>' + esc(t('win_time')) + '</span></div>'
            + '<div><b>' + (SET.check === 'solution' ? G.mistakes : '–') + '</b><span>' + esc(t('win_mistakes')) + '</span></div>'
            + '<div><b>' + G.hints + '</b><span>' + esc(t('win_hints')) + '</span></div></div>';
        var note = assisted ? t('win_assisted') : (out.bestTime ? t('win_record') : (best != null ? t('win_best') + ': ' + GK.formatTime(best) : ''));
        var extra = '';
        var needed = neededText(G);
        if (needed) extra += '<p class="sdk-techs">' + esc(t('win_needed')) + ': ' + esc(needed) + '</p>';
        if (G.source === 'daily') {
            var streak = stats.dailyStreak(GK.dailyKey());
            if (streak > 1) extra += '<p class="sdk-techs">' + esc(t('win_streak', { n: streak })) + '</p>';
        }
        var size = G.size, level = S.LEVELS[size][G.level] ? G.level : 'easy';
        setTimeout(function () {
            if (!G || !G.done) return;
            showOver({
                kind: 'win', title: t('win_title'), html: res, text: note, extra: extra,
                actions: [
                    { label: t('win_next'), main: true, run: function () { showOver(null); startLevel(size, level); } },
                    { label: t('win_share'), run: function () { share(true); } },
                    { label: t('close'), run: function () { showOver(null); } }
                ]
            });
        }, 650);
        paintDaily();
        paintStats();
    }
    // "What this puzzle needed" — the techniques above plain singles.
    function neededText(g) {
        if (!g.techs) return '';
        var parts = [];
        S.TECHNIQUES.forEach(function (row) {
            var name = row[0];
            if (row[1] < 2 || !g.techs[name] || !H.name || !H.name[name]) return;
            parts.push(g.techs[name] > 1 ? t('win_times', { tech: H.name[name], n: g.techs[name] }) : H.name[name]);
        });
        return parts.join(', ');
    }
    function lose() {
        G.lost = true;
        clock.pause();
        save();
        funnel('sudoku_lost', { level: G.level, size: G.size });
        showOver({
            kind: 'lost', title: t('lost_title'), text: t('lost_text'),
            actions: [
                { label: t('lost_continue'), main: true, run: function () { showOver(null); resumeClock(); } },
                { label: t('lost_restart'), run: function () { showOver(null); restart(); } }
            ]
        });
        return true;
    }
    function restart() {
        if (!G) return;
        var puzzle = { size: G.size, level: G.level, givens: S.format(G.givens, '0'), solution: S.format(G.solution, '0'), techs: G.techs, seed: G.seed };
        open(puzzle, G.source, { day: G.day, beat: G.beat });
    }

    // ── The hint ladder ──────────────────────────────────────────────────────
    function boardForHint() {
        var notes = [];
        for (var i = 0; i < geo.cells; i++) notes.push(shownNotes(i));
        return { size: G.size, values: G.values, solution: G.solution, notes: notes, strictNotes: SET.autoNotes, unique: true };
    }
    function askHint() {
        if (mode !== 'play' || !G || G.done || over || paused) return;
        if (hint && hint.rung < 3) { hint.rung++; paintHint(); feature('hint', { rung: hint.rung, tech: hintTech() }); return; }
        if (hint) { applyHint(); return; }
        var res = S.hint(boardForHint());
        if (res.kind === 'done') { toast(t('t_solved_already'), 'info'); return; }
        begin();
        G.hints++;
        hint = { res: res, rung: walking ? 3 : 1 };
        save();
        paintHint();
        feature('hint', { rung: hint.rung, tech: hintTech() });
    }
    function hintTech() { return hint ? (hint.res.kind === 'step' ? hint.res.step.tech : hint.res.kind) : ''; }
    function closeHint() {
        if (!hint) return;
        hint = null;
        hintEl.hidden = true;
        paintHintButton(null);
        if (G && cells.length) paintAll();
    }
    // While a hint is open the pad's own Hint button carries it on: one more
    // step, then the deed itself — the same button all the way.
    function paintHintButton(words) {
        var btn = $('sdkHintBtn'), label = btn.querySelector('span');
        var text = !hint ? t('hint') : (hint.rung < 3 ? t('hint_more_short') : words.apply);
        if (label.textContent !== text) label.textContent = text;
        btn.classList.toggle('is-go', !!hint && hint.rung >= 3);
    }
    function hintWords() {
        var res = hint.res, out = { where: '', name: '', how: '', why: '', apply: t('hint_apply') };
        if (res.kind === 'mistake') {
            return { where: H.mistake_where, name: H.mistake_name, how: '', why: H.mistake_why, apply: t('hint_remove') };
        }
        if (res.kind === 'note') {
            return { where: H.note_where, name: H.note_name, how: '', why: tr(H.note_why, { d: res.digit }), apply: t('hint_restore', { d: res.digit }) };
        }
        var step = res.step, f = step.focus, tech = step.tech;
        var d = step.digits && step.digits[0];
        out.where = f.type === 'unit' ? tr(H.where_unit, { unit: unitName(f.units[0]) })
            : (f.type === 'digit' ? tr(H.where_digit, { d: f.digit }) : H.where_cells);
        out.name = (H.name && H.name[tech]) || tech;
        out.how = (H.how && H.how[tech]) || '';
        var key = tech, vars = { d: d, ds: listText(step.digits || []) };
        if (step.unit != null && step.unit >= 0) vars.unit = unitName(step.unit);
        if (step.unit2 != null && step.unit2 >= 0) vars.unit2 = unitName(step.unit2);
        if (/^naked_(pair|triple|quad)$/.test(tech)) key = 'naked_subset';
        else if (/^hidden_(pair|triple|quad)$/.test(tech)) key = 'hidden_subset';
        else if (tech === 'x_wing' || tech === 'swordfish' || tech === 'jellyfish') {
            key = 'fish';
            var rows = S.unitKind(geo, step.base[0]) === 'row';
            vars.lines = t(rows ? 'u_rows' : 'u_cols', { list: listText(step.base.map(function (u) { return S.unitIndex(geo, u) + 1; })) });
            vars.covers = t(rows ? 'u_cols' : 'u_rows', { list: listText(step.cover.map(function (u) { return S.unitIndex(geo, u) + 1; })) });
        } else if (tech === 'xy_wing' || tech === 'xyz_wing') vars.pd = listText(step.pivotDigits);
        else if (tech === 'w_wing') vars.ld = step.linkDigit;
        else if (tech === 'simple_coloring') key = step.kind === 'wrap' ? 'coloring_wrap' : 'coloring_trap';
        else if (tech === 'forcing') {
            vars.n = step.chain.length;
            vars.wall = step.wall.kind === 'cell' ? H.wall_cell : tr(H.wall_unit, { d: step.wall.digit, unit: unitName(step.wall.unit) });
        }
        out.why = tr((H.why && H.why[key]) || '', vars);
        out.apply = step.place ? t('hint_place', { d: step.place[0][1] }) : t('hint_cross');
        return out;
    }
    function paintHint() {
        if (!hint) return;
        var w = hintWords();
        // A hint with nothing general to say about its technique (a wrong
        // digit, a crossed-out note) goes from "where" straight to the answer.
        if (hint.rung === 2 && !w.how) hint.rung = 3;
        var rung = hint.rung, last = rung >= 3;
        var rungs = hintEl.querySelectorAll('.sdk-rungs i');
        for (var i = 0; i < rungs.length; i++) rungs[i].classList.toggle('on', i < rung);
        $('sdkHintName').textContent = rung === 1 ? t('hint_step', { n: 1 }) : w.name;
        $('sdkHintText').textContent = rung === 1 ? w.where : (rung === 2 ? w.how : w.why);
        var more = $('sdkHintMore'), apply = $('sdkHintApply');
        more.hidden = last;
        apply.hidden = !last;
        apply.textContent = walking ? w.apply + ' → ' + t('hint_next') : w.apply;
        paintHintButton(w);
        $('sdkHintClose').textContent = walking ? t('walk_stop') : t('close');
        hintEl.hidden = false;
        statusEl.hidden = true;
        hintEl.setAttribute('aria-label', t('hint_step', { n: hint.rung }));
        say((rung === 1 ? '' : w.name + '. ') + $('sdkHintText').textContent);
        paintAll();
        try { hintEl.scrollIntoView({ block: 'nearest' }); } catch (_) {}
    }
    function applyHint() {
        if (!hint) return;
        var res = hint.res;
        remember();
        if (res.kind === 'mistake') {
            res.cells.forEach(function (c) { G.values[c] = 0; });
        } else if (res.kind === 'note') {
            var bit = 1 << (res.digit - 1);
            if (SET.autoNotes) G.excl[res.cell] &= ~bit; else G.notes[res.cell] |= bit;
        } else {
            var step = res.step;
            (step.place || []).forEach(function (p) { G.values[p[0]] = p[1]; cleanPeers(p[0], p[1]); lastPop = p[0]; });
            if (step.elim && step.elim.length) {
                // The cells of the pattern get their candidates written down —
                // a deduction about notes is of no use on a board without them.
                var seen = {};
                (step.cand || []).forEach(function (c) { seen[c[0]] = c[1]; });
                step.elim.forEach(function (e) {
                    if (SET.autoNotes) { G.excl[e[0]] |= e[1]; return; }
                    if (seen[e[0]] != null) seen[e[0]] &= ~e[1];
                });
                if (!SET.autoNotes) Object.keys(seen).forEach(function (c) { if (!G.values[c]) G.notes[c] = seen[c]; });
            }
        }
        hint = null;
        hintEl.hidden = true;
        paintHintButton(null);
        settle('');
        if (walking && G && !G.done) askHint();
        else walking = false;
    }
    $('sdkHintMore').addEventListener('click', function () { askHint(); });
    $('sdkHintApply').addEventListener('click', applyHint);
    $('sdkHintClose').addEventListener('click', function () { walking = false; closeHint(); });
    $('sdkHintX').addEventListener('click', function () { walking = false; closeHint(); });

    function startWalk() {
        if (mode !== 'play' || !G || G.done) return;
        closeHint();
        walking = true;
        askHint();
    }

    // ── A puzzle of one's own ────────────────────────────────────────────────
    function setSetupMsg(text, kind) {
        var el = $('sdkSetupMsg');
        el.textContent = text || '';
        el.className = 'sdk-setup-msg' + (kind ? ' is-' + kind : '');
    }
    function enterSetup(size, values) {
        closeHint();
        walking = false;
        if (mode !== 'setup') { stash = G; clock.pause(); }
        mode = 'setup';
        geo = S.geometry(size);
        var blank = [];
        for (var i = 0; i < geo.cells; i++) blank.push(0);
        E = { size: size, values: values ? values.slice() : blank, marks: null };
        sel = [0];
        armed = 0;
        notesMode = false;
        showOver(null);
        rebuildBoard();
        setSetupMsg('', '');
        paintAll();
        try { stage.scrollIntoView({ block: 'nearest' }); } catch (_) {}
        feature('own', { step: 'enter', size: size });
    }
    function leaveSetup(restore) {
        if (mode !== 'setup') return;
        mode = 'play';
        E = null;
        if (stash) { G = stash; stash = null; geo = S.geometry(G.size); }
        sel = [];
        rebuildBoard();
        if (restore !== false) { paintAll(); resumeClock(); }
    }
    function checkSetup(thenWalk) {
        if (mode !== 'setup') return;
        var clues = 0;
        E.values.forEach(function (v) { if (v) clues++; });
        if (!clues) { setSetupMsg(t('own_few'), 'bad'); return; }
        var clash = S.conflicts(geo, E.values);
        if (clash.length) { setSetupMsg(t('own_conflict'), 'bad'); paintAll(); return; }
        setSetupMsg(t('own_checking'), '');
        var size = E.size, values = E.values.slice();
        work({ cmd: 'analyze', values: values, size: size }).then(function (m) {
            if (mode !== 'setup') return;
            var r = m.result;
            feature('own', { step: 'check', status: r.status, level: r.level || '' });
            if (r.status === 'ok') {
                var puzzle = { size: size, level: r.level, givens: S.format(values, '0'), solution: S.format(r.solution, '0'), techs: r.grade.techs };
                stash = null;
                open(puzzle, 'own');
                toast(t('own_ok', { level: levelName(r.level) }), 'success');
                if (thenWalk) startWalk();
                return;
            }
            E.marks = null;
            if (r.status === 'many') {
                E.marks = {};
                r.differ.forEach(function (c) { E.marks[c] = 1; });
            }
            setSetupMsg(t(r.status === 'many' ? 'own_many' : (r.status === 'none' ? 'own_none' : (r.status === 'conflict' ? 'own_conflict' : 'own_unknown'))), 'bad');
            paintAll();
        }, function (err) {
            fail(err, 'sudoku_analyze', t('own_unknown'));
            setSetupMsg(t('own_unknown'), 'bad');
        });
    }
    $('sdkSetupGo').addEventListener('click', function () { checkSetup(false); });
    $('sdkSetupWalk').addEventListener('click', function () { checkSetup(true); });
    $('sdkSetupClear').addEventListener('click', function () { if (mode === 'setup') enterSetup(E.size); });
    $('sdkSetupCancel').addEventListener('click', function () { leaveSetup(true); });
    $('sdkOwnStart').addEventListener('click', function () {
        var size = +$('sdkOwnSize').value || 9;
        if (mode === 'setup') enterSetup(size); else guard(function () { enterSetup(size); });
    });
    var ownText = $('sdkOwnText'), ownTimer = null;
    function readOwnText() {
        var msg = $('sdkOwnMsg'), text = ownText.value;
        msg.textContent = '';
        if (!text.replace(/\s/g, '')) return;
        // A link to this page carries a puzzle too.
        var shared = fromLink(text);
        var parsed = shared ? { ok: true, n: shared.size, values: S.parse(shared.givens).values } : S.parse(text);
        if (!parsed.ok) {
            msg.textContent = parsed.error === 'chars' ? t('own_err_chars')
                : (parsed.error === 'digit' ? t('own_err_digit', { size: parsed.n }) : t('own_err_length', { n: parsed.count }));
            return;
        }
        $('sdkOwnSize').value = String(parsed.n);
        if (mode === 'setup') enterSetup(parsed.n, parsed.values); else guard(function () { enterSetup(parsed.n, parsed.values); });
    }
    ownText.addEventListener('input', function () {
        clearTimeout(ownTimer);
        ownTimer = setTimeout(readOwnText, 350);
    });

    // ── Links ────────────────────────────────────────────────────────────────
    // The link holds the givens themselves, not a seed: it must open the same
    // puzzle after any change to the generator.
    function linkFor(withTime) {
        var data = { v: 1, n: G.size, g: S.format(G.givens, '0'), l: G.level };
        if (withTime && G.done && !G.hints) data.t = clock.elapsed();
        return String(CFG.url || location.href).split('#')[0] + '#p=' + GK.share.encode(data);
    }
    function fromLink(text) {
        // The printed QR code carries the board as plain digits.
        var plain = /[#&?]g=([0-9]{16,81})(?![0-9])/.exec(String(text || ''));
        if (plain) {
            var board = S.parse(plain[1]);
            return board.ok ? { size: board.n, givens: S.format(board.values, '0'), level: '', beat: 0 } : null;
        }
        var m = /[#&?]p=([A-Za-z0-9_-]+)/.exec(String(text || ''));
        if (!m) return null;
        var data = GK.share.decode(m[1]);
        if (!data || typeof data !== 'object' || typeof data.g !== 'string') return null;
        var parsed = S.parse(data.g);
        if (!parsed.ok) return null;
        return { size: parsed.n, givens: S.format(parsed.values, '0'), level: typeof data.l === 'string' ? data.l : '', beat: +data.t > 0 ? +data.t : 0 };
    }
    function share(withTime) {
        if (!G || mode !== 'play') return;
        var url = linkFor(withTime);
        feature('share', { level: G.level, size: G.size });
        var done = function (ok) { toast(t(ok ? 't_link_copied' : 't_link_failed'), ok ? 'success' : 'warning'); };
        if (typeof window.__copyText === 'function') window.__copyText(url).then(done, function () { done(false); });
        else done(false);
    }
    function openShared(link) {
        var geo2 = S.geometry(link.size), values = S.parse(link.givens).values;
        var found = S.solve(geo2, values, { limit: 2 });
        if (found.invalid || found.count !== 1) { toast(t('t_link_bad'), 'warning'); return false; }
        var graded = S.grade(geo2, values, { maxTier: 7, unique: true, solution: found.solution });
        open({ size: link.size, level: S.levelOfTier(graded.tier), givens: link.givens, solution: S.format(found.solution, '0'), techs: graded.techs }, 'shared', { beat: link.beat });
        return true;
    }

    // ── The puzzle of the day ────────────────────────────────────────────────
    function paintDaily() {
        var today = GK.dailyKey(), day = calDay || today;
        $('sdkDailyDate').textContent = day === today ? t('daily_today') + ', ' + formatDay(day) : formatDay(day, true);
        Array.prototype.forEach.call(document.querySelectorAll('#sdkDayLevels .sdk-day'), function (b) {
            var level = b.getAttribute('data-daily');
            var done = !!stats.dailyResult(day, '9:' + level);
            b.classList.toggle('is-done', done);
            b.classList.toggle('is-now', !!G && G.source === 'daily' && G.day === day && G.level === level && mode === 'play');
            b.setAttribute('aria-label', levelName(level) + (done ? ', ' + t('daily_done') : ''));
        });
        var streak = stats.dailyStreak(today), el = $('sdkStreak');
        el.hidden = streak < 1;
        el.textContent = t('daily_streak', { n: streak });
        if ($('sdkCalWrap').open) paintCalendar();
    }
    function paintCalendar() {
        var today = GK.dailyKey(), tp = today.split('-');
        if (!calMonth) calMonth = { y: +tp[0], m: +tp[1] - 1 };
        var first = new Date(calMonth.y, calMonth.m, 1), days = new Date(calMonth.y, calMonth.m + 1, 0).getDate();
        var loc = locale(), title;
        try { title = first.toLocaleDateString(loc, { month: 'long', year: 'numeric' }); } catch (_) { title = calMonth.y + '-' + (calMonth.m + 1); }
        var weekStart = firstWeekday(loc);                 // 0 Sunday … 6 Saturday
        var lead = (first.getDay() - weekStart + 7) % 7;
        var atCurrent = calMonth.y === +tp[0] && calMonth.m === +tp[1] - 1;
        var html = '<div class="sdk-cal-head"><button type="button" class="sdk-cal-nav" data-cal="-1" aria-label="' + esc(t('daily_prev')) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg></button>'
            + '<span class="sdk-cal-month">' + esc(title) + '</span>'
            + '<button type="button" class="sdk-cal-nav" data-cal="1"' + (atCurrent ? ' disabled' : '') + ' aria-label="' + esc(t('daily_next')) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg></button></div><div class="sdk-cal-grid">';
        for (var w = 0; w < 7; w++) {
            var ref = new Date(2024, 0, 7 + weekStart + w), name;   // 7 January 2024 is a Sunday
            try { name = ref.toLocaleDateString(loc, { weekday: 'short' }); } catch (_) { name = ''; }
            html += '<span class="sdk-cal-dow" aria-hidden="true">' + esc(name) + '</span>';
        }
        for (var b = 0; b < lead; b++) html += '<span></span>';
        var picked = calDay || today;
        for (var d = 1; d <= days; d++) {
            var key = GK.dailyKey(new Date(calMonth.y, calMonth.m, d)), solved = 0;
            LEVELS.forEach(function (level) { if (stats.dailyResult(key, '9:' + level)) solved++; });
            var future = key > today;
            html += '<button type="button" class="sdk-cal-day no-tap-floor' + (key === today ? ' is-today' : '') + (key === picked ? ' is-pick' : '') + '" data-day="' + key + '"'
                + (future ? ' disabled' : '') + (solved ? ' data-done="' + solved + '"' : '')
                + ' aria-label="' + esc(formatDay(key) + (solved ? ', ' + t('daily_count', { n: solved, total: LEVELS.length }) : '')) + '">' + d + '</button>';
        }
        $('sdkCal').innerHTML = html + '</div>';
        Array.prototype.forEach.call($('sdkCal').querySelectorAll('[data-done]'), function (el) {
            el.style.setProperty('--part', String(+el.getAttribute('data-done') / LEVELS.length));
        });
    }
    // The first day of the week as the reader's locale has it; Monday when the
    // browser cannot say.
    function firstWeekday(loc) {
        try {
            var L = new Intl.Locale(loc || 'en');
            var info = (typeof L.getWeekInfo === 'function' && L.getWeekInfo()) || L.weekInfo;
            if (info && info.firstDay) return info.firstDay % 7;
        } catch (_) {}
        return 1;
    }
    $('sdkCal').addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || b.disabled) return;
        if (b.hasAttribute('data-cal')) {
            var m = calMonth.m + (+b.getAttribute('data-cal'));
            calMonth = { y: calMonth.y + Math.floor(m / 12), m: ((m % 12) + 12) % 12 };
            paintCalendar();
        } else if (b.hasAttribute('data-day')) {
            calDay = b.getAttribute('data-day');
            paintDaily();
            say(t('daily_pick', { date: formatDay(calDay) }));
        }
    });
    $('sdkCalWrap').addEventListener('toggle', function () { if (this.open) paintCalendar(); });
    $('sdkDayLevels').addEventListener('click', function (e) {
        var b = e.target.closest('.sdk-day');
        if (!b) return;
        var level = b.getAttribute('data-daily'), day = calDay || GK.dailyKey();
        guard(function () { startDaily(level, day); });
    });

    // ── Statistics ───────────────────────────────────────────────────────────
    function paintStats() {
        var rows = '', any = false;
        [9, 6, 4].forEach(function (size) {
            Object.keys(S.LEVELS[size]).forEach(function (level) {
                var s = stats.summary(size + ':' + level);
                if (!s.played) return;
                any = true;
                rows += '<tr><td>' + esc(levelName(level)) + (size === 9 ? '' : ' ' + size + '×' + size) + '</td><td class="num">' + s.won + '</td><td class="num">'
                    + (s.bestMs != null ? GK.formatTime(s.bestMs) : '–') + '</td><td class="num">' + (s.avgMs != null ? GK.formatTime(s.avgMs) : '–') + '</td></tr>';
            });
        });
        $('sdkStatsBody').innerHTML = any
            ? '<div class="tc-tablewrap"><table class="tc-table"><thead><tr><th>' + esc(t('level')) + '</th><th>' + esc(t('stats_won')) + '</th><th>' + esc(t('stats_best')) + '</th><th>' + esc(t('stats_avg')) + '</th></tr></thead><tbody>' + rows + '</tbody></table></div>'
            : '<p class="sdk-stats-empty">' + esc(t('stats_empty')) + '</p>';
    }

    // ── Settings ─────────────────────────────────────────────────────────────
    function applySettings() {
        stage.classList.toggle('lefty', !!SET.lefty);
        $('sdkSetCheck').value = SET.check;
        Array.prototype.forEach.call(document.querySelectorAll('#sdkSettings [data-set]'), function (box) { box.checked = !!SET[box.getAttribute('data-set')]; });
        $('sdkCheck').hidden = SET.check === 'solution';
        if (!SET.digitFirst) armed = 0;
    }
    $('sdkSettings').addEventListener('change', function (e) {
        var el = e.target;
        if (el.id === 'sdkSetCheck') SET.check = el.value;
        else if (el.hasAttribute('data-set')) {
            var key = el.getAttribute('data-set');
            if (key === 'autoNotes' && G && mode === 'play') switchNotes(el.checked);
            SET[key] = el.checked;
        } else return;
        saveSettings();
        applySettings();
        if (G) { save(); paintAll(); }
        feature('setting', { key: el.id === 'sdkSetCheck' ? 'check' : el.getAttribute('data-set'), on: el.id === 'sdkSetCheck' ? el.value : (el.checked ? 1 : 0) });
    });
    // Notes change their meaning with the switch, so what is on screen is
    // carried over: hand-written notes become "what was crossed out", and back.
    function switchNotes(toAuto) {
        var i;
        if (toAuto) {
            for (i = 0; i < geo.cells; i++) {
                G.excl[i] = (!G.values[i] && G.notes[i]) ? (basicMask(G.values, i) & ~G.notes[i]) : 0;
            }
        } else {
            for (i = 0; i < geo.cells; i++) G.notes[i] = G.values[i] ? 0 : (basicMask(G.values, i) & ~G.excl[i]);
        }
    }

    // ── Buttons around the board ─────────────────────────────────────────────
    $('sdkLevels').addEventListener('click', function (e) {
        var b = e.target.closest('.tc-seg-b');
        if (!b) return;
        var level = b.getAttribute('data-level'), size = mode === 'setup' && stash ? stash.size : (G ? G.size : 9);
        guard(function () { startLevel(size, level); });
    });
    $('sdkSize').addEventListener('change', function () {
        var size = +this.value || 9, level = G && S.LEVELS[size][G.level] ? G.level : 'easy';
        var back = G ? String(G.size) : '9', self = this;
        if (gameInProgress()) self.value = back;
        guard(function () { startLevel(size, level); });
    });
    $('sdkNew').addEventListener('click', function () {
        var size = G ? G.size : 9, level = G && S.LEVELS[size][G.level] ? G.level : 'easy';
        guard(function () { startLevel(size, level); });
    });
    $('sdkMenuBtn').addEventListener('click', openMenu);
    $('sdkPause').addEventListener('click', function () { setPaused(!paused); });
    $('sdkShare').addEventListener('click', function () { share(false); });
    $('sdkRestart').addEventListener('click', function () { if (G && mode === 'play') guard(restart, 'restart'); });
    $('sdkWalk').addEventListener('click', startWalk);
    $('sdkCheck').addEventListener('click', function () {
        if (!G || mode !== 'play') return;
        var wrong = [];
        for (var i = 0; i < geo.cells; i++) if (G.values[i] && G.values[i] !== G.solution[i]) wrong.push(i);
        if (!wrong.length) { toast(t('t_check_ok'), 'success'); return; }
        begin();
        G.hints++;
        hint = { res: { kind: 'mistake', cells: wrong }, rung: 3 };
        save();
        paintHint();
        toast(t('t_check_bad', { n: wrong.length }), 'warning');
    });

    // ── The whole screen ─────────────────────────────────────────────────────
    immersive = GK.immersive(stage, {
        key: SLUG,
        onChange: function (on, how) {
            var btn = $('sdkFull');
            btn.classList.toggle('is-on', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            btn.setAttribute('aria-label', t(on ? 'full_exit' : 'full'));
            btn.title = t(on ? 'full_exit' : 'full');
            if (on) feature('immersive', { mode: how });
        }
    });
    $('sdkFull').addEventListener('click', function () { immersive.toggle(); });

    // ── Print ────────────────────────────────────────────────────────────────
    function loadChain(urls) {
        urls = (urls || []).filter(Boolean);
        if (window.__assetChain && window.__assetChain.loadScript) return window.__assetChain.loadScript(urls, 'sudoku-print');
        return new Promise(function (resolve, reject) {
            (function tryAt(k) {
                if (k >= urls.length) return reject(new Error('script failed'));
                var s = document.createElement('script');
                s.src = urls[k];
                s.async = true;
                s.onload = function () { resolve(urls[k]); };
                s.onerror = function () { tryAt(k + 1); };
                document.head.appendChild(s);
            })(0);
        });
    }
    var printing = false;
    $('sdkPrintGo').addEventListener('click', function () {
        if (printing) return;
        var btn = this, busy = $('sdkPrintBusy');
        var size = +$('sdkPrintSize').value || 9, level = $('sdkPrintLevel').value;
        var per = +$('sdkPrintPer').value || 4, pages = +$('sdkPrintPages').value || 1;
        var total = per * pages, levels = Object.keys(S.LEVELS[size]), items = [];
        for (var i = 0; i < total; i++) {
            var lv = level === 'mixed' ? levels[Math.floor(i * levels.length / total)] : (S.LEVELS[size][level] ? level : levels[levels.length - 1]);
            items.push({ size: size, level: lv, seed: randomSeed() });
        }
        printing = true;
        btn.disabled = true;
        busy.textContent = t('print_busy', { n: 0, total: total });
        var puzzles = [], A = CFG.assets || {};
        var libs = Promise.all([
            window.PDFLib ? null : loadChain(A.pdfLib),
            window.PdfTextFont ? null : loadChain(A.pdfFont),
            window.SudokuPrint ? null : loadChain(A.print),
            $('sdkPrintQr').checked && !window.qrcode ? loadChain(A.qr).catch(function () { return null; }) : null
        ]);
        var made = work({ cmd: 'batch', items: items }, function (m) {
            puzzles.push(m.puzzle);
            busy.textContent = t('print_busy', { n: m.progress, total: total });
        });
        Promise.all([libs, made]).then(function () {
            return window.SudokuPrint.build({
                puzzles: puzzles, perPage: per, paper: $('sdkPrintPaper').value, answers: $('sdkPrintAnswers').checked,
                qr: $('sdkPrintQr').checked && !!window.qrcode,
                // Digits only after the address: a code made of digits is small
                // enough to scan from paper at 15 mm.
                link: function (p) { return { head: String(CFG.url || location.href).split('#')[0] + '#g=', digits: p.givens }; },
                words: { title: t('print_h'), answers: t('print_answers_h'), num: T.print_num, scan: t('print_scan'), brand: CFG.brand || '', level: function (l) { return levelName(l); } }
            });
        }).then(function (blob) {
            feature('print', { size: size, level: level, per: per, pages: pages });
            return window.__downloadFile(blob, t('print_file') + '-' + level + '-' + size + 'x' + size + '.pdf');
        }).catch(function (err) {
            fail(err, 'sudoku_print', t('t_pdf_failed'));
        }).then(function () {
            printing = false;
            btn.disabled = false;
            busy.textContent = '';
        });
    });

    // ── Leaving and coming back ──────────────────────────────────────────────
    window.addEventListener('pagehide', save);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') save(); });
    setInterval(function () { if (G && G.started && !G.done && clock.running()) save(); }, 15000);

    // ── Start ────────────────────────────────────────────────────────────────
    function loadSaved() {
        var st = store(), d = st ? st.load(SLUG, SAVE_KEY, null) : null;
        if (!d || d.v !== 1 || d.dn || typeof d.g !== 'string' || !S.LEVELS[d.n]) return false;
        var parsed = S.parse(d.g);
        if (!parsed.ok || parsed.n !== d.n) return false;
        var g2 = S.geometry(d.n), found = S.solve(g2, parsed.values, { limit: 2 });
        if (found.invalid || found.count !== 1) return false;
        newGame({ size: d.n, level: String(d.l || 'easy'), givens: d.g, solution: S.format(found.solution, '0'), seed: d.seed }, String(d.src || 'random'), { day: d.day, beat: d.beat });
        restoreSnapshot(String(d.c || ''));
        // A saved board must still be the same puzzle: the givens stay put.
        for (var i = 0; i < geo.cells; i++) if (G.givens[i]) G.values[i] = G.givens[i];
        G.mistakes = +d.mi || 0;
        G.hints = +d.hi || 0;
        G.started = !!d.st;
        G.lost = !!d.lost;
        G.undo = Array.isArray(d.un) ? d.un.filter(function (x) { return typeof x === 'string'; }) : [];
        clock.reset(+d.ms || 0);
        var graded = S.grade(geo, G.givens, { maxTier: 7, unique: true, solution: G.solution });
        G.techs = graded.techs;
        return true;
    }

    (function start() {
        var st = store(), saved = st ? st.load(SLUG, SET_KEY, null) : null;
        if (saved && typeof saved === 'object') {
            Object.keys(SET).forEach(function (k) { if (typeof saved[k] === typeof SET[k]) SET[k] = saved[k]; });
        }
        applySettings();

        var link = fromLink(location.hash), restored = loadSaved();
        if (!restored) {
            var starter = boardEl.getAttribute('data-givens') || '';
            newGame({ size: 9, level: 'easy', givens: starter }, 'random');
            G.techs = S.grade(geo, G.givens, { maxTier: 5 }).techs;
        }
        rebuildBoard();
        stage.removeAttribute('data-boot');
        paintAll();
        paintClock();
        paintDaily();
        paintStats();
        if (restored && G.started) { toast(t('t_restored'), 'info'); clock.start(); }
        if (restored) save();

        if (link) {
            try { history.replaceState(null, '', location.pathname + location.search); } catch (_) {}
            if (S.format(G.givens, '0') !== link.givens) guard(function () { openShared(link); }, 'link');
        }

        // Taps made before this script woke.
        if (window.__earlyAction) {
            window.__earlyAction.claim('sudoku-cell', link ? null : function (a, el) { var i = +el.getAttribute('data-i'); if (i >= 0 && i < geo.cells) tapCell(i, {}); });
            window.__earlyAction.claim('sudoku-pad', restored || link ? null : function (a) {
                if (a.indexOf('d:') === 0) padDigit(+a.slice(2)); else padAction(a);
            });
            window.__earlyAction.claim('sudoku', restored || link ? null : function (a) {
                if (a.indexOf('level:') === 0) startLevel(9, a.slice(6));
                else if (a === 'new') startLevel(9, 'easy');
                else if (a === 'menu') openMenu();
            });
        }
        prepare(G.size, S.LEVELS[G.size][G.level] ? G.level : 'easy');
    })();

    // A handle for tests and for the walkthrough capture script.
    window.__sudoku = {
        game: function () { return G; },
        settings: function () { return SET; },
        mode: function () { return mode; },
        hint: function () { return hint; }
    };
})();
